import { apiSlice } from "./apiSlice";

/** @const {Object} Record search behind Ctrl/Cmd+K Quick Jump. */
export const globalSearchApiSlice = apiSlice.injectEndpoints({
  endpoints: builder => ({
    getGlobalSearch: builder.query({
      query: q => ({ url: "/api/search/", params: { q } }),
      transformResponse: response => response?.results || [],
      keepUnusedDataFor: 30,
    }),
  }),
});

export const { useGetGlobalSearchQuery } = globalSearchApiSlice;
